import { Accordion, Box, useMantineTheme } from "@mantine/core";
import { useRouter } from "next/router";
import { PropsWithChildren, ReactElement } from "react";
import { ACCORDION_SECTION_VALUE } from "../AccordionSection/constants";
import { IAccordionCustomProps } from "./types";
import { ACCORDION_TRANSITION_DURATION } from "./constants";
import {
  useGetCurrentSection,
  useScrollToSection,
} from "@common/hooks/useScrollToSection";
import { handleCancelledRouteError } from "@common/utils/router";

export default function AccordionCustom({
  id,
  sections = [],
  defaultSection,
  children,
  ...boxProps
}: PropsWithChildren<IAccordionCustomProps>): ReactElement {
  const theme = useMantineTheme();
  const router = useRouter();

  // scroll
  const currentSection = useGetCurrentSection(id, sections);
  useScrollToSection(currentSection, defaultSection, id);

  return (
    <Box id={id} maw={theme.breakpoints.sm} {...boxProps}>
      <Accordion
        id={id}
        transitionDuration={ACCORDION_TRANSITION_DURATION}
        defaultValue={currentSection || defaultSection}
        value={currentSection || defaultSection}
        onChange={(value) => {
          if (value && value !== ACCORDION_SECTION_VALUE) {
            router
              .replace({
                hash: `section=${value}`,
              })
              .catch(handleCancelledRouteError);
          }
        }}
      >
        {children}
      </Accordion>
    </Box>
  );
}
